import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {
  Box,
  Link as MuiLink,
  styled,
  Typography,
  BoxProps,
  // Checkbox,
} from '@mui/material';
import Checkbox from '@jobseeker/lotus/elements/CheckBox';

import {useEffect, useState} from 'react';

export const Link = styled(MuiLink)(() => ({
  textDecoration: 'none',
}));

interface LabeledComponentProps extends BoxProps {
  title?: string;
  value?: string | string[];
  invert?: boolean;
}

export const CheckboxLabel = ({defaultChecked, onChange, ...props}: any) => {
  const isLarge = useIsLargeDevice();
  const [checked, setChecked] = useState(defaultChecked ?? false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onChange(event.target.checked);
  };
  useEffect(() => {
    if (checked) {
      onChange(checked);
    }
  }, []);

  return (
    <Checkbox
      // size={isLarge ? 'medium' : 'small'}
      checked={checked}
      onChange={handleChange}
      inputProps={{'aria-label': 'controlled'}}
      {...props}
    />
  );
};

export const LabeledComponent = ({
  title,
  invert,
  value,
  ...props
}: LabeledComponentProps) => (
  <Box my={1} {...props}>
    {title && (
      <Typography
        component={'p'}
        lineHeight={'21px'}
        color={invert ? 'text.primary' : 'text.secondary'}
        fontSize={{xxs: 14}}
        fontWeight={invert ? 500 : 400}
        variant="subtitle2"
      >
        {title ?? 'Industry'}
      </Typography>
    )}

    {Array.isArray(value) ? (
      value.map((v, i) => (
        <Typography
          key={`labeled-component-${i}`}
          component={'p'}
          lineHeight={'21px'}
          fontSize={{xxs: 14}}
          variant="subtitle2"
          fontWeight={invert ? 400 : 500}
          color={!invert ? 'text.primary' : 'text.secondary'}
        >
          {v ?? 'Something should be here'}
        </Typography>
      ))
    ) : (
      <Typography
        component={'p'}
        lineHeight={'16px'}
        fontSize={{xxs: 14}}
        variant="subtitle2"
        fontWeight={invert ? 400 : 500}
        color={!invert ? 'text.primary' : 'text.secondary'}
      >
        {value ?? 'Something should be here'}
      </Typography>
    )}
  </Box>
);
